import { render, staticRenderFns } from "./NphThankyou.vue?vue&type=template&id=3496ac77"
import script from "./NphThankyou.vue?vue&type=script&lang=js"
export * from "./NphThankyou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports